<template>
  <div id="app">
      <router-view />
  </div>
</template>

<script>
import "mint-ui/lib/style.css";
// import reponeFont from './config/reponeFont.js'
import "swiper/dist/css/swiper.css";

console.log(`App version: ${_APP_.VERSION} (build date: ${_APP_.BUILD_DATE})`);

export default {
  name: "App"
};
</script>
